import Image from 'next/image'
import React from 'react'

export default function Sec5() {
  return (
    <div>
      <section className="font-inter">
        <div className="grid md:col-span-12 relative">
          <div className="">
            <div className="font-bold leading-[1.1111111111111112] lg:text-[45px] md:text-[35px] max-w-[400px] pb-6 mb-16 lg:max-w-[650px] ">
              <span className="font-semibold lg:leading-[40px] lg:text-[40px] text-[35px] w-[600px] h-[98px]">
                Maximize engagement with powerful features
              </span>
              <div className="pt-5 text-[#9D34DA] flex gap-2 text-[16px]">
                <h1>
                  Learn more about Notion AI security practices{' '}
                  <span className="ml-[.2em]">→</span>
                </h1>
              </div>
            </div>

            <Image
              alt="Image"
              src="/ai/eye-only-peek.png"
              width={98}
              height={56}
              className="z-1000000 absolute right-[3%] bottom-1"
            />
          </div>
        </div>

        <div className="border-none bg-transparent rounded-md mt-[-33px] lg:width-full ">
          <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 lg:gap-6 gap-3 md:gap-6 my-8 w-[full] h-auto">
            <div className="border-gray-100 bg-gray-100 rounded-lg">
              <div className="px-8 w-[280px] py-8">
                <Image width={20} height={20} alt="" src="/ai/Shield.png" />
                <h2 className="font-semibold py-2">No training on your data</h2>
                <p>
                  We have contractual agreements with our AI subprocessors that
                  prohibit the use of customer data to train their models.
                </p>
              </div>
            </div>
            <div className="border-gray-100 bg-gray-100 rounded-lg">
              <div className="px-8 w-[280px] py-8">
                <Image width={20} height={20} alt="" src="/ai/lock.png" />
                <h2 className="font-semibold py-2">Secure encryption</h2>
                <p>
                  When you use Notion AI, your data is encrypted in-transit
                  using TLS 1.2 or greater.
                </p>
              </div>
            </div>
            <div className="border-gray-100 bg-gray-100 rounded-lg">
              <div className="px-8 w-[280px] py-8">
                <Image
                  width={20}
                  height={20}
                  alt=""
                  src="/ai/User-Verified.png"
                />
                <h2 className="font-semibold py-2">Advanced permissions</h2>
                <p>
                  Specify who can do and create what, with granular precision.
                </p>
              </div>
            </div>
            <div className="border-gray-100 bg-gray-100 rounded-lg">
              <div className="px-8 w-[280px] py-8">
                <Image width={20} height={20} alt="" src="/ai/Verified.png" />
                <h2 className="font-semibold py-2">GDPR & CCPA</h2>
                <p>
                  We have mapped our privacy program to the GDPR and other
                  global privacy regulations.
                </p>
              </div>
            </div>
            <div className="border-gray-100 bg-gray-100 rounded-lg">
              <div className="px-8 w-[280px] py-8">
                <Image width={20} height={20} alt="" src="/ai/Shield.png" />
                <h2 className="font-semibold py-2">SOC 2 (Type 2)</h2>
                <p>
                  Our report certifies that our security policies and controls
                  continuously meet the highest industry standards.
                </p>
              </div>
            </div>
            <div className="border-gray-100 bg-gray-100 rounded-lg">
              <div className="px-8 w-[280px] py-8">
                <Image width={20} height={20} alt="" src="/ai/Stamp.png" />
                <h2 className="font-semibold py-2">ISO 27001</h2>
                <p>
                  Notion is ISO 27001 certified, showing our commitment to the
                  highest requirements of information security.
                </p>
              </div>
            </div>
            <div className="border-gray-100 bg-gray-100 rounded-lg">
              <div className="px-8 w-[280px] py-8">
                <Image width={20} height={20} alt="" src="/ai/Vector.png" />
                <h2 className="font-semibold py-2">SCIM user provisioning</h2>
                <p>
                  Easily create, remove, add, update, or retrieve any user or
                  group.
                </p>
                <button className="border-[#8029b3] bg-[#8029b3] rounded-xl text-white px-3 mt-3">
                  Enterprise Plan
                </button>
              </div>
            </div>
            <div className="border-gray-100 bg-gray-100 rounded-lg">
              <div className="px-8 w-[280px] py-8">
                <Image width={20} height={20} alt="" src="/ai/Security.png" />
                <h2 className="font-semibold py-2">Security & admin tools</h2>
                <p>
                  Keep your workspace safe with security, compliance, analytics,
                  and auditing tools.
                </p>
                <button className="border-[#8029b3] bg-[#8029b3] rounded-xl text-white px-3 mt-3">
                  Enterprise Plan
                </button>
              </div>
            </div>
            <div className="border-gray-100 bg-gray-100 rounded-lg">
              <div className="px-8 w-[280px] py-8">
                <Image width={20} height={20} alt="" src="/ai/Verified.png" />
                <h2 className="font-semibold py-2">SAML single sign-on</h2>
                <p>
                  Give employees access to Notion through your identity provider
                  using SAML-based SSO.
                </p>
                <button className="border-[#8029b3] bg-[#8029b3] rounded-xl text-white px-3 mt-3">
                  Enterprise Plan
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}
